/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <karolpawlak.giap@gmail.com>, August 2020
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import AttachmentsPanel from '../../components/AttachmentsPanel';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import loadingData from './loading';
import _ from 'lodash';

import v from './validators';
import fetch from '../../core/fetch/fetch.server';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const type1Options = [
  {
    label: 'tradycyjny',
    value: 'tradycyjny',
    state: 'type1',
  },
  {
    label: 'dziecięcy',
    value: 'dziecięcy',
    state: 'type1',
  },
];

const type2Options = [
  {
    label: 'ziemny',
    value: 'ziemny',
    state: 'type2',
  },
  {
    label: 'murowany',
    value: 'murowany',
    state: 'type2',
  },
];

const type3Options = [
  {
    label: 'poziomy',
    value: 'poziomy',
    state: 'type3',
  },
  {
    label: 'pionowy',
    value: 'pionowy',
    state: 'type3',
  },
];

const type4Options = [
  {
    label: '1 osoby',
    value: '1 osoby',
    state: 'type4',
  },
  {
    label: '2 osób',
    value: '2 osób',
    state: 'type4',
  },
];

const type5Options = [
  {
    label: '5 lat',
    value: '5',
    state: 'type5',
  },
  {
    label: '10 lat',
    value: '10',
    state: 'type5',
  },
  {
    label: '20 lat',
    value: '20',
    state: 'type5',
  },
];

const InfoTypeDict = {
  type1: {
    label: 'Rodzaj 1:',
    editable: true,
    type: 'Select',
    options: type1Options,
  },
  type2: {
    label: 'Rodzaj 2:',
    editable: true,
    type: 'Select',
    options: type2Options,
  },
  type3: {
    label: 'Rodzaj 3:',
    editable: true,
    type: 'Select',
    options: type3Options,
  },
  type4: {
    label: 'Miejsce grzebalne dla:',
    editable: true,
    type: 'Select',
    options: type4Options,
  },
  type5: {
    label: 'Okres dzierżawy grobu:',
    editable: true,
    type: 'Select',
    options: type5Options,
  },
};


class DzierzawaMiejscaGrzebalnego extends React.Component {
  state = {
    info: {
      type1: null,
      type2: null,
      type3: null,
      type4: null,
      type5: null,
    },
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    selectedParcels: [],
    attachments: null,
    loading: false,
  };

  validators = {
    type1: [v.NotSelected],
    type2: [v.NotSelected],
    type3: [v.NotSelected],
    type4: [v.NotSelected],
    type5: [v.NotSelected],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });
  }


  onHide = () => this.setState({ showError: false });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  }

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      info: {
        type1: 'tradycyjny',
        type2: 'ziemny',
        type3: 'poziomy',
        type4: '1 osoby',
        type5: '10',
      },
    });
  };

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          dzialki: [],
          selectedParcels: [],
          info: this.state.info,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.setState({
            loading: false }, () =>
            this.redirectToSummary(resp.jobId));
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />
        <DecisionContainer
          title={'1. Informacje'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={InfoTypeDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />
        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}/>

        <GrayPanel title={'Cennik'} >
          <p>(zgodnie z Uchwałą Nr XXXIII/226/17 w sprawie ustalenia opłat za korzystanie z Cmentarza Komunalnego w Jezioranach i urządzeń cmentarnych)</p>
          <br />
          <p>1) Opłaty za miejsce grzebalne (brutto):</p>
          <p>a) za miejsce dla zwłok dziecka do 6-ciu lat: <b>140,00 zł</b>;</p>
          <p>b) za miejsce dla zwłok osoby dorosłej lub dziecka powyżej 6-ciu lat: <b>280,00 zł</b>;</p>
          <p>c) za miejsce dla zwłok ekshumowanych: <b>280,00 zł</b>;</p>
          <br />
          <p>2) opłaty za rezerwację miejsca (brutto):</p>
          <p>a) za miejsce na okres 5 lat: <b>205,00 zł</b>;</p>
          <p>b) za miejsce na okres 10 lat: <b>395,00 zł</b>;</p>
          <p>c) za miejsce na okres 20 lat: <b>650,00 zł</b>;</p>
          <br />
          <p>3) opłata za miejsce grzebalne z prawem do murowania grobowca (brutto):</p>
          <p>a) dla zwłok jednej osoby: <b>1210,00 zł</b>;</p>
          <p>b) dla zwłok dwóch osób w poziomie: <b>2360,00 zł</b>;</p>
          <p>c) dla zwłok dwóch osób w pionie: <b>1960,00 zł</b>;</p>
        </ GrayPanel>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

DzierzawaMiejscaGrzebalnego.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(DzierzawaMiejscaGrzebalnego),
);



// WEBPACK FOOTER //
// src/routes/eservices/DzierzawaMiejscaGrzebalnego.js